module.exports = __webpack_public_path__ + "img/plus.f548615e.svg";